module.exports = __webpack_public_path__ + "static/media/moustache-emoji-svgrepo-com (1).1d332ee1.svg";